import * as React from 'react';

interface ItemMasterDetailHeaderProps {
  isShipper: boolean;
}

export const ItemMasterDetailHeader: React.FC<ItemMasterDetailHeaderProps> = ({isShipper}) => (
  <div className="row">
    <div className="col-sm-6 space-below">
      <div className="breadcrumbs">
        <a href={isShipper ? '/s/inventories' : '/wh/inventories'}>Item Master</a>
        <i className="fa fa-angle-right"></i>
        SKU Details
      </div>
    </div>
  </div>
);
